<template>
  <div id="modal" class="modal estimate_modal" v-show="modalShown">
    <div class="modal-main wrapper" id="estimate_main">
      <!-- <div class="cross_btn" @click="onCancel()"></div> -->
      <div class="cross_btn2" @click="onCancel()">
        <span class="css-cancel"></span>
      </div>
      <div class="estimate_area" v-if="isProductData">
        <div class="estimate_title">
          <h3 v-if="!isNetPrice">見積り書</h3>
          <h3 v-else>NET見積り書</h3>
        </div>
        <div class="estimate_info">
          <section class="estimation">
            <h3 class="title" v-if="!isNetPrice">見積り明細</h3>
            <h3 v-else>NET見積り明細</h3>
            <dd-price
              :itemName="fileName"
              :priceData="priceData"
              :targetPlan="targetPlan"
              :dcProductCount="dcProductCount"
              :isCalcDelivery="isCalcDelivery"
              v-if="!isHaseko"
            />
            <dd-price-hrf
              :itemName="fileName"
              :priceData="priceData"
              :targetPlan="targetPlan"
              :dcProductCount="dcProductCount"
              :isCalcDelivery="isCalcDelivery"
              :isNetPrice="isNetPrice"
              v-else
            />
            <div v-if="resrchFlag" class="resrch_price_list">
              <div class="title">事前調査費 見積り</div>
              <!-- <div id="est_title">{{fileName}}</div> -->
              <dd-resrch-price
                :priceData="priceData"
              />
              <!-- <div v-if="resrchFlag">
                <h2 class="title">事前調査費 見積り</h2>
                <div id="est_title">{{fileName}}</div>
                <dd-resrch-price
                  :priceData="priceData"
                />
              </div> -->
            </div>
            <div class="pickup pickup_price">※ 金額は予告なく変更となる場合がございます。</div>
            <div class="pickup pickup_price" v-if="priceData.delivaryPrice <= 0">※ 本商品は商品代金に配送料が含まれています。</div>
            <div v-if="!isHaseko">
              <div class="maker-corp middle_text" v-if="makerData && makerData.corpName">
                <div>製造会社</div>
                <div>この商品は、{{makerData.corpName}}が製造し、発送します。</div>
                <div class="maker_info">
                  <ul>
                    <li>{{makerData.corpName}}</li>
                    <li class="indent_1">〒{{makerData.postcd}}</li>
                    <li class="indent_1">{{makerData.state}}{{makerData.city}}{{makerData.street}}{{makerData.branch}}</li>
                    <li class="indent_1">TEL.{{makerData.tel}}</li>
                    <li v-if="makerData.fax" class="indent_1">FAX.{{makerData.fax}}</li>
                    <li class="caution indent_1">※自動メールにて返信しますので{{mailTo}}からのメールを受信許可に設定してください。</li>
                  </ul>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="maker-corp middle_text">
                <ul>
                  <li class="maker_corp_info">株式会社&nbsp;&nbsp;長谷工リフォーム</li>
                  <li class="maker_corp_info indent_1">〒105-0014&nbsp;&nbsp;東京都港区芝2-6-1&nbsp;&nbsp;長谷工芝二ビル</li>
                  <li class="maker_corp_info indent_1">TEL&nbsp;&nbsp;03-3457-7713</li>
                </ul>
                <table class="haseko_table">
                  <tr>
                    <th class="maker_caution_th1"></th>
                    <th class="maker_caution_th2"></th>
                  </tr>
                  <tr>
                    <td class="maker_caution_td">※</td>
                    <td class="maker_caution_td">設置場所や搬入経路の状況により、金額が変動する場合があります。</td>
                  </tr>
                  <tr>
                    <td class="maker_caution_td"></td>
                    <td class="maker_caution_td">確認のため、事前に現地調査をさせていただきます。</td>
                  </tr>
                  <tr>
                    <td class="maker_caution_td">※</td>
                    <td class="maker_caution_td">次のような場合に別途工事（有償）が発生します。</td>
                  </tr>
                  <tr>
                    <td class="maker_caution_td"></td>
                    <td class="maker_caution_td">取付下地がない場合/コンセントを移設・増設する場合/</td>
                  </tr>
                  <tr>
                    <td class="maker_caution_td"></td>
                    <td class="maker_caution_td">天井面に障害物がある場合/不要品処分がある場合</td>
                  </tr>
                </table>
              </div>
            </div>
          </section>
          <section id="color">
            <h3 class="title">カラー</h3>
            <ul class="color_list">
              <li v-if="colorDoor">
                <dd-color
                  :title="titleDoor"
                  :color="colorDoor"
                />
              </li>
              <li v-if="colorCabine">
                <dd-color
                  :title="titleCabine"
                  :color="colorCabine"
                />
              </li>
              <li v-if="colorCounter">
                <dd-color
                  :title="titleCounter"
                  :color="colorCounter"
                />
              </li>
            </ul>
          </section>
          <!-- <section id="size">
            <h3 class="title">梱包サイズ</h3>
          </section> -->
        </div>
        <div class="corp_info_area2" v-if="!isHaseko">
          <div class="corp_logo">
            <img :src="getImage('common/domanslogo_copyright.svg')" />
          </div>
          <!-- <div class="space"></div> -->
          <div class="logo_domans logo_footer">
            <img :src="this.getImage('common/mmstylelogo_catch.svg')" />
          </div>
        </div>
        <div class="corp_info_area2" v-else>
          <div class="corp_logo">
            <div id="copyright">Copyright ©{{year}} domans all rights reserved. </div>
          </div>
          <!-- <div class="space"></div> -->
          <div class="logo_haseko logo_footer logo_side">
            <img :src="this.getImage('common/logo_rashiku.webp')" />
          </div>
        </div>
      </div>
      <section v-if="isDrawing" id="noinfo_sheet" class="print_view page-always" >
        <h3 id="title">図面</h3>
        <dd-sheet
          ref="sheetModalRef"
          :spaceJoincd="spaceJoincd"
          :isPreview=false
          :svgWidth="svgWidth"
          :svgHeight="svgHeight"
          @showModal="delayShowModal"
        />
        <div class="corp_info_area2 print_hidden" v-if="!isHaseko">
          <div class="corp_logo">
            <img :src="getImage('common/domanslogo_copyright.svg')" />
          </div>
          <!-- <div class="space"></div> -->
          <div class="logo_domans logo_footer logo_side">
            <img :src="this.getImage('common/mmstylelogo_catch.svg')" />
          </div>
        </div>
        <div class="corp_info_area2 print_hidden" v-else>
          <div class="corp_logo">
            <div id="copyright">Copyright ©{{year}} domans all rights reserved. </div>
          </div>
          <!-- <div class="space"></div> -->
          <div class="logo_haseko logo_footer logo_side">
            <img :src="this.getImage('common/logo_rashiku.webp')" />
          </div>
        </div>
      </section>
      <!-- <section id="carry_caution">
        <div>
          <h3>商品搬入時の注意点</h3>
          <p>
            搬入時に、家具が入らなくて困ることがあります。室内開口部やマンションのエレベータ、階段幅など狭い箇所を事前に採寸し、梱包サイズが搬入できるかご確認ください。<br>
            トイレや収納スペースなどの狭い場所では、スペースぴったりのサイズで作成すると、ドア枠や窓枠などに引っかかり、搬入できない恐れがあります。<br>
            狭い場所では、商品本体のサイズを小さめに作成し、フィラーを活用することで搬入が可能となります。
          </p>
          <div>
            <img :src="getImage('common/noimage.png')" style="width:20rem;">
          </div>
        </div>
      </section> -->
      <section class="consent-area" v-if="isConsentImg">
        <div class="consent_title">設置場所確認リスト</div>
        <div>
          <div class="consent-img-area">
            <img :src="getImage(consentImg)" />
          </div>
          <div class="check_box">
            <input type="checkbox" id="consentRule" v-model="isConsent"/>
            <label for="consentRule">全ての項目を確認しました。</label>
          </div>
        </div>
      </section>
      <div class="button-area">
        <div class="success-btn-area">
          <div class="main_btn act_sub_btn icon_btn" @click="preview()" v-if="isDrawing" v-on:mouseover="isOnPreview(true)" v-on:mouseleave="isOnPreview(false)">
            <img :src="imgPreview" class="icon">
            <div>プレビュー</div>
          </div>
          <div class="main_btn act_sub_btn icon_btn" @click="print()" v-on:mouseover="isOnPrint(true)" v-on:mouseleave="isOnPrint(false)">
            <img :src="imgPrint" class="icon">
            <div>印刷</div>
          </div>
          <div :class="{main_btn: true, sel_main_btn: true, icon_btn: true, disabled: isConsentDisable}" @click="onOrder()" v-if="dispOrderButton" v-on:mouseover="isOnCart(true)" v-on:mouseleave="isOnCart(false)">
            <img :src="imgCart" class="icon">
            <a>{{orderTitle}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as App from '../../../../../utils/App'
import * as AppEc from '../../../../utils/AppEc'
import * as Check from '../../../../../utils/Check'

import {DC_STORAGE_KEY, STRUCT_CORP_ID_ST, STRUCT_CORP_ID_ED} from '../../../../../constants/App'
import PriceList from '../../../payment/PriceList'
import PriceListHrf from '../../../payment/PriceListHrf'
import PriceResrchList from '../../../payment/ResrchPrice'
import Color from '../color/DcColor'
import Sheet from './DcEstimateSheet'

export default {
  name: 'estimateModal',
  components: {
    'dd-color': Color,
    'dd-price': PriceList,
    'dd-price-hrf': PriceListHrf,
    'dd-sheet': Sheet,
    'dd-resrch-price': PriceResrchList
  },
  props: {
    /** OK押下時コールバック */
    onOk: {
      type: Function,
      default: function () {}
    },
    onSearch: {
      type: Function,
      default: function () {}
    },
    /** コールバックに渡す引数 */
    callbackParams: {
      type: Object,
      default: function () { return {} }
    },
    showSuccess: {
      type: Function,
      default: function () {}
    },
    dcFdId: Number,
    fileName: {
      type: String,
      default: ''
    },
    titleDoor: {
      type: String
    },
    colorDoor: {
      type: Object
    },
    titleCabine: {
      type: String
    },
    colorCabine: {
      type: Object
    },
    titleCounter: {
      type: String
    },
    colorCounter: {
      type: Object
    },
    priceData: {
      type: Object
    },
    targetPlan: {
      type: Object,
      default: undefined
    },
    spaceJoincd: String,
    dispOrderButton: {
      type: Boolean,
      default: true
    },
    dcProductCount: Number,
    isCalcDelivery: Boolean,
    resrchFlag: {
      type: Boolean,
      default: false
    },
    isDrawing: Boolean,
    makerData: {
      type: Object,
      default: undefined
    },
    isProductData: {
      type: Boolean,
      default: true
    },
    consentImg: {
      type: String,
      default: undefined
    },
    isNetPrice: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      svgWidth: '100%',
      svgHeight: '100%',
      imgPreview: this.getImage('common/preview_black.svg'),
      imgPrint: this.getImage('common/print_black.svg'),
      imgCart: this.getImage('common/cart_white.svg'),
      isConsent: false,
      userInfo: {},
      year: ''
    }
  },
  watch: {
  },
  computed: {
    orderTitle: function () {
      if (this.resrchFlag) {
        return '注文する'
      } else {
        return 'カートに追加'
      }
    },
    mailTo: function () {
      return '「@domans.co.jp」、「@candeal.co.jp」'
    },
    isConsentImg: function () {
      if (!this.consentImg) {
        return false
      }
      return true
    },
    isConsentDisable: function () {
      if (!this.consentImg) return false
      return !this.isConsent
    },
    isHaseko: function () {
      return (this.userInfo && this.userInfo.corpId >= STRUCT_CORP_ID_ST && this.userInfo.corpId <= STRUCT_CORP_ID_ED)
    }
  },
  methods: {
    showModal: function () {
    },
    route: function (name, params) {
      this.$router.push({
        name: name,
        query: params
      })
    },
    delayShowModal: function () {
      this.showSuccess(this.callbackParams)
      // 図面が完成してから表示
      this.modalShown = true
      this.$nextTick(function () {
        if (!Check.isBrawserIE()) return
        let modalWidth = document.getElementById('estimate_main').clientWidth
        let modalHeight = document.getElementById('estimate_main').clientHeight
        // 親領域のpadding、右のスクロールバーを引く
        this.svgWidth = (modalWidth - 20 - 20) + 'px'
        this.svgHeight = modalHeight * 0.6 + 'px'
      })
    },
    onCancel: function () {
      this.modalShown = false
      document.body.style.overflow = 'scroll'
    },
    onOrder: function () {
      if (!this.modalShown) return
      this.onOk(this.callbackParams)
      this.modalShown = false
    },
    handleScroll: function (event) {
      event.preventDefault()
    },
    preview: function () {
      let modalData = {
        svgWidth: '90%',
        spaceJoincd: this.spaceJoincd,
        isShowInfo: true
      }
      AppEc.showPreview(modalData)
    },
    print: function () {
      window.print()
    },
    isOnPreview: function (on) {
      if (on) {
        this.imgPreview = this.getImage('common/preview_white.svg')
      } else {
        this.imgPreview = this.getImage('common/preview_black.svg')
      }
    },
    isOnPrint: function (on) {
      if (on) {
        this.imgPrint = this.getImage('common/print_white.svg')
      } else {
        this.imgPrint = this.getImage('common/print_black.svg')
      }
    },
    isOnCart: function (on) {
      if (on) {
        this.imgCart = this.getImage('common/cart_red.svg')
      } else {
        this.imgCart = this.getImage('common/cart_white.svg')
      }
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    onOutRange: function () {
      this.modalShown = false
    }
  }, // end method
  mounted: function () {
  },
  created: function () {
    if (!this.isDrawing) this.delayShowModal()
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    let date = new Date()
    this.year = date.getFullYear()
  }
}
</script>
<style src="../../../../css/dc-order.scss" lang="scss" scoped></style>
<style src="../../../../css/print.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/top/input/estimate/DcEstimateModal.vue